/**
 * Payment-related API service functions
 */
import apiClient from './apiClient';

export const paymentService = {
  /**
   * Create Stripe checkout session
   * @param {Object} bookingData - Booking information
   * @param {number} amount - Total amount
   * @returns {Promise} Stripe session details
   */
  createStripeSession: async (bookingData, amount, bookingToken = null) => {
    return apiClient.post('/payments/stripe/create-session', {
      booking_data: bookingData,
      amount: amount,
      booking_token: bookingToken
    });
  },

  /**
   * Create PayPal payment
   * @param {Object} bookingData - Booking information
   * @param {number} amount - Total amount
   * @returns {Promise} PayPal payment details
   */
  createPayPalPayment: async (bookingData, amount, bookingToken = null) => {
    return apiClient.post('/payments/paypal/create-payment', {
      booking_data: bookingData,
      amount: amount,
      booking_token: bookingToken
    });
  },

  /**
   * Get payment history
   * @returns {Promise} List of payments
   */
  getPaymentHistory: async () => {
    return apiClient.get('/payments/history');
  },

  /**
   * Verify Stripe payment session
   * @param {string} sessionId - Stripe session ID
   * @returns {Promise} Payment verification result
   */
  verifyStripePayment: async (sessionId) => {
    return apiClient.get(`/payments/stripe/verify/${sessionId}`);
  },

  /**
   * Confirm free rebooking (when no payment is required)
   * @param {string} bookingToken - Booking token
   * @returns {Promise} Confirmation result
   */
  confirmFreeRebooking: async (bookingToken) => {
    return apiClient.post('/payments/rebooking/confirm-free', {
      booking_token: bookingToken
    });
  }
};

export default paymentService;
